module.exports = __webpack_public_path__ + "media/trifold.106cd286.mp4";